import React, { Suspense, useState, useEffect, useRef } from "react";
import { CommonUtilities } from "../../commonUtils";
import projectServices from "./projectServices";
import Modal from "react-responsive-modal";

export default function NewClassList (param:any) {

    let [saveAlert, initsaveAlert] = useState(false);
    const formValidation = useRef<HTMLDivElement>(null);
    let [invalidField, initinvalidField] = useState(false);
    let [deleteAlert, initdeleteAlert] = useState(false);
    const [classListItem, initclassListItem] = useState<any>([]);
    let [newClassList, initnewClassList] = useState<any[]>([]);

    const saveClassList =() =>{

        var validSave = handleFieldRequired(newClassList) ; 
        if(validSave){
            projectServices.classlistsave(newClassList).then((res)=>{ 
                initsaveAlert(true)
            })

        }else{
            initinvalidField(true)
        }
        setTimeout(function(){
            initsaveAlert(false);
            initinvalidField(false);
        }, 3000);


    };

    const closePopUpClassList = (e:any) =>{
        param.onchangeCloseClassList(e)
    }

    const handleFieldChange = (e :any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;       
        
        console.log( Field_value)
        console.log( Field_type)
        if( Field_type === "checkbox"){
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');
        
        let updatedObject = { ...classListItem };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        } 

        console.log(updatedObject);
        initclassListItem(updatedObject);


    };  

    const handleFieldRequired = (object :any ) => { 
        const inputs :any  = formValidation.current?.querySelectorAll('input');
        var valid = true;                
        
        Object.values(inputs).map((values :any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');
            
            if(isRequired) { 
                if(!object[values.id]) { 
                    var fieldName : any  = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        } )

        return valid;
    };

    return (

        <>
        <Modal open={param.open} onClose={() => closePopUpClassList("close")} >
            
            <div className="box">
                <div className="box-header-main">
                    <h2><i className="fa fa-money"></i> New Class List</h2>
                </div>

                <div className="box-content">
                    <div className="row-fluid"> 
                        {invalidField && <div className="alert alert-danger"> There was a problem submitting your request, one or more fields are missing or incorrect. </div>}
                        {saveAlert && <div className="alert alert-success"> Class List Details have been saved successfully  </div>  }                  
                        {deleteAlert && <div className="alert alert-success">Class List has been deleted successfully </div>}

                        <div className="row-fluid"  ref={formValidation}>
                            <div className="ws-6">
                                <div className="form-format ws-7">
                                    <label >ReleaseISRC*</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter ReleaseISRC" onChange={(e)=>handleFieldChange(e)} value={classListItem.releaseISRC} id="releaseISRC" maxLength={50}  name="releaseISRC" required/>
                                    </div>
                                </div>
                                <div className="form-format ws-7">
                                    <label >Class List*</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter Class List" onChange={(e)=>handleFieldChange(e)} value={classListItem.classList} id="classList" maxLength={75}  name="classList" required/>
                                    </div>
                                </div>
                                <div className="form-format ws-7">
                                    <label>ReleaseAlt1</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter ReleaseAlt1" onChange={(e)=>handleFieldChange(e)} value={classListItem.releaseAlt1} id="releaseAlt1" maxLength={75} name="releaseAlt1" />
                                    </div>
                                </div>
                                <div className="form-format ws-7">
                                    <label>ReleaseAlt2</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter ReleaseAlt2" onChange={(e)=>handleFieldChange(e)} value={classListItem.releaseAlt2} id="releaseAlt2" maxLength={75} name="releaseAlt2" />
                                    </div>
                                </div>
                            </div>
                            <div className="ws-6">
                                <div className="form-format ws-7">
                                    <label>ReleaseAlt3</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter ReleaseAlt3" onChange={(e)=>handleFieldChange(e)} value={classListItem.releaseAlt3} id="releaseAlt3" maxLength={75} name="releaseAlt3" />
                                    </div>
                                </div>
                                <div className="form-format ws-7">
                                    <label>ReleaseAlt4</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter ReleaseAlt4" onChange={(e)=>handleFieldChange(e)} value={classListItem.releaseAlt4} id="releaseAlt4" maxLength={75} name="releaseAlt4" />
                                    </div>
                                </div>
                                <div className="form-format ws-7">
                                    <label>ReleaseAlt5</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter ReleaseAlt5" onChange={(e)=>handleFieldChange(e)} value={classListItem.releaseAlt5} id="releaseAlt5" maxLength={75} name="releaseAlt5" />
                                    </div>
                                </div>
                                <div className="form-format ws-7">
                                    <label>ReleaseAlt6</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter ReleaseAlt6" onChange={(e)=>handleFieldChange(e)} value={classListItem.releaseAlt6} id="releaseAlt6" maxLength={75} name="releaseAlt6" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div className="box-footer pull-right">
                    <button className="icon-btn info btn-sm" ng-click="frmClassListing.$submitted =false; reset(frmClassListing, classListItem)">
                        <i className="fa fa-refresh"></i> Reset
                    </button>
                    <button className="icon-btn edit btn-sm" onClick={saveClassList}><i className="fa fa-save"></i> Save </button>
                    <button className="icon-btn delete btn-sm" onClick={()=>closePopUpClassList("close")}><i className="fa fa-close"></i> Close </button>

                </div>
            </div>

        </Modal>
        </>
    )
}